export default __webpack_public_path__ + "static/media/logo192x192.d0aa5240.png";